<template>
	<div>
		<b-modal ref="modal" hide-footer>
			<template v-slot:modal-title>
				{{ $t('horse.recherche_transpondeur') }}
			</template>

			<div class="text-center">
				<h2>{{ transpondeur }}</h2>

				<LoadingSpinner v-if="loading" class="col-12" />

				<RegularBuyPlan v-if="!has_right" @purchased="hideRegularPurchase" />
				<div v-else-if="processing_ajout">
					<h3>{{ $t('horse.ajout_horse') }} <font-awesome-icon :icon="['fal', 'spinner']" spin /></h3>
				</div>
				<div v-else-if="add_manuel">
					<button @click="openManuelCreation" class="w-100 btn btn-primary">{{ $t('horse.manual_add') }} <font-awesome-icon :icon="['fal', 'angle-right']" /></button>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script type="text/javascript">
	import Horse from '@/mixins/Horse.js'
	import Actions from '@/mixins/Actions.js'

	export default {
		name: 'ImportHorseMicroship',
		mixins: [Horse, Actions],
		data () {
			return {
				action: '',
				transpondeur: '',
				loading: false,
				has_right: true,
				processing_ajout: false,
				add_manuel: false
			}
		},

		methods: {
			async openModal(params) {
				this.action = params.action
				this.transpondeur = params.transpondeur
				this.$refs.modal.show()

				this.loading = true
				const horse = await this.getHorseByTranspondeur(this.transpondeur)
				this.loading = false

				if(horse) {
					this.$refs.modal.hide()
					this[this.action](horse.horse_id)
					return false
				}

				this.has_right = await this.checkCanAdd()
				if(this.has_right) {
					this.processing_ajout = true
					const result = await this.addHorseByTranspondeur(this.transpondeur)

	                if(!result) {
	                    this.processing_ajout = false
	                    this.add_manuel = true
	                    return
	                }

	                const errors = result.retour.errors
	                if(errors.length > 0) {
	                    this.failureToast(this.getTrad("toast.add_horse_transpondeur_error") + ' ' + errors.join(', '))
	                    this.processing_ajout = false
	                    this.add_manuel = true
	                    return
	                }

	                await this.$sync.force() 
	                this.successToast("toast.info_save_succes")
	                this.processing_ajout = false
					this.$refs.modal.hide()

	                const ids = result.retour.ids
	                if(ids.length > 0) {
	                	this[this.action](ids[0])
	                }
	                this.processing_ajout = false
				}
			},

			hideRegularPurchase() {
				this.has_right = true
			},

			openManuelCreation() {
				this.$refs.modal.hide()
				this.$router.push({ name: 'AddManuel', params: { transpondeur: this.transpondeur, action: this.action }})
			},
		},

		components: {
            LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
			RegularBuyPlan: () => import('@/components/Plans/BuyPlan')
		}
	}

</script>